import * as THREE from "three";
import * as TWEEN from "three/examples/jsm/libs/tween.module";
import { ref } from "vue";
import { Line2 } from "three/addons/lines/Line2.js";
import { LineMaterial } from "three/addons/lines/LineMaterial.js";
import { LineGeometry } from "three/addons/lines/LineGeometry.js";
import ModelItems from "./model.json";

const points1 = [
  { x: -174.83053319083422, y: 2, z: 61.20261639973261 },
  { x: -173.06855802715313, y: 2, z: 67.24941978597941 },
  { x: -152.35816517059135, y: 2, z: 56.94154443947632 },
  { x: -109.10046371038312, y: 2, z: 49.48264015111344 },
  { x: -107.36971248445599, y: 2, z: 1.635508742778329 },
  { x: -105.47283027311839, y: 2, z: -20.78983579296226 },
  { x: -109.08983756804456, y: 2, z: -21.2656184821746 },
  { x: -110.9517066209968, y: 2, z: -21.125183592651158 },
  { x: -110.86944031719833, y: 2, z: -23.705714163658676 },
];
const points2 = [
  { x: -114.82236360362995, y: 20.194156172625117, z: -18.06860052006201 },
  { x: -110.86944031719833, y: 2, z: -23.705714163658676 },
  { x: -111.38139372695419, y: 2, z: -34.735125673104605 },
  { x: -111.30684243870387, y: 2, z: -38.29707526426258 },
  { x: -101.74821075621433, y: 2, z: -37.605939936793604 },
  { x: -98.0784799940615, y: 2, z: -68.84873429430057 },
  { x: -19.636476620037016, y: 2, z: -69.72652390263177 },
  { x: -15.164674111219497, y: 2, z: -80.12361594678933 },
  { x: -24.91760855325507, y: 2, z: -93.42200730552288 },
  { x: -19.21648200436414, y: 2, z: -96.52174460595651 },
  { x: -16.992328983848463, y: 2, z: -98.64893711868348 },
  { x: -15.727846705075413, y: 2, z: -99.92976478567635 },
];
const points3 = [
  // { x: -16.992328983848463, y: 2, z: -98.64893711868348 },
  // { x: -10.79952956513105, y: 2, z: -104.56644511695252 },
  // { x: -2.454876642768276, y: 2, z: -112.6644293932231 },
  // { x: 44.49370316863971, y: 2, z: -64.68259012274933 },
  // { x: 45.60721713548938, y: 5, z: -47.11410040554422 },
];
const points4 = [
  { x: -16.2939380156945, y: 5.199925720279107, z: -100.2970150273196 },
  { x: -10.79952956513105, y: 2, z: -104.56644511695252 },
  { x: -2.454876642768276, y: 2, z: -112.6644293932231 },
  { x: 44.49370316863971, y: 2, z: -64.68259012274933 },
  { x: 45.60721713548938, y: 5, z: -47.11410040554422 },
  { x: 49.820667665772945, y: 5, z: -44.97744066961666 },
  { x: 53.77706815682767, y: 5, z: -40.056387705471515 },
  { x: 54.208493364626136, y: 5, z: -33.19742946353669 },
  { x: 51.81120677373937, y: 5, z: -26.75713517485267 },
  { x: 51.035546690202715, y: 5, z: -25.03079631972322 },
  { x: 52.77429612229185, y: 5, z: -23.6593781375296 },
];
const points5 = [
  { x: 51.72591835138111, y: 21.511568580274545, z: -29.963124984921606 },
  { x: 52.77429612229185, y: 5, z: -23.6593781375296 },
  { x: 65.19149775780028, y: 5, z: -10.793574831720697 },
  { x: 66.76596503140242, y: 5, z: -8.805153705520949 },
  { x: 66.3497866007064, y: 5, z: -3.834769539331422 },
  { x: 65.01936992830014, y: 5, z: -0.7291504685325934 },
  { x: 58.06035253020892, y: 2, z: -2.2028205736931867 },
  { x: 51.55755559870479, y: 2, z: -2.7372072556553984 },
  { x: 50.05569930744186, y: 2, z: -2.7583527328619084 },
  { x: 50.254176629944325, y: 4, z: 4.139933988531766 },
  { x: 49.0853335431736, y: 4, z: 4.236133241592945 },
  { x: 49.07570365299555, y: 7, z: 0.047423449475790136 },
  { x: 46.672015985740856, y: 7, z: -0.01771758831972159 },
];
const points6 = [
  { x: 43.31194478484418, y: 7, z: 1.8298627664652074 },
  { x: 23.372119349848642, y: 7, z: 1.9903987674331844 },
  { x: 22.86565784848486, y: 7, z: 19.28865011236818 },
  { x: 19.185438805665402, y: 7, z: 32.7590004858627 },
  { x: 17.937116348266496, y: 7, z: 34.7390916870397 },
  { x: 9.556707235074605, y: 3, z: 35.017439384801094 },
];
const points7 = [
  { x: 24.437476594520604, y: 41.339680015921246, z: 19.89713055455814 },
  { x: 9.556707235074605, y: 3, z: 35.017439384801094 },
  { x: 9.44116185701688, y: 3, z: 36.76553452813512 },
  { x: 47.48027497599587, y: 2, z: 36.71682065780723 },
  { x: 51.74167926478786, y: 2, z: 36.2573315547274 },
  { x: 51.29976887237038, y: 2, z: 50.74041107365417 },
  { x: 7.242584418963693, y: 2, z: 49.943570910004375 },
  { x: 6.0650200596049, y: 2, z: 68.62515392009237 },
];
const points8 = [
  { x: 11.221795078357163, y: 36.88634341213497, z: 57.041247450952945 },
  { x: 19.838061993038174, y: 2, z: 49.88993157322536 },
  { x: 20.264417319753274, y: 2, z: 68.8859518369531 },
  { x: 20.143685863940448, y: 6, z: 74.16501161917118 },
  { x: 21.143685863940448, y: 6, z: 74.89163823687739 },
  //二楼
  { x: 21.143685863940448, y: 8, z: 72.62586492374183 },
  { x: 21.569354188752566, y: 8, z: 70.30394905377416 },
  { x: 21.569354188752566, y: 8, z: 66.30394905377416 },
  { x: 21.569354188752566, y: 8, z: 63.862248157047254 },
  { x: 19.569354188752566, y: 8, z: 63.862248157047254 },
  { x: 2.8908422652443733, y: 8, z: 63.862248157047254 },
  { x: 1.8908422652443733, y: 8, z: 64.862248157047254 },
  { x: 1.8908422652443733, y: 8, z: 73.29454732206058 },
  { x: 2.8908422652443733, y: 8, z: 74.07011841173752 },
  { x: 18.5622770924426, y: 8, z: 74.07011841173752 },
  { x: 18.737970744570273, y: 8, z: 70.29454651698587 },
  { x: 19.75873663019282, y: 8, z: 69.23171022384554 },
  { x: 20.28610585908347, y: 8, z: 69.41460378390302 },
  { x: 20.175733738189177, y: 8, z: 71.22510298455289 },
  { x: 20.143685863940448, y: 10.2, z: 74.16501161917118 },
  { x: 21.143685863940448, y: 10.2, z: 74.89163823687739 },
  //三楼
  { x: 21.143685863940448, y: 12.5, z: 72.62586492374183 },
  { x: 21.569354188752566, y: 12.5, z: 70.30394905377416 },
  { x: 21.569354188752566, y: 12.5, z: 66.30394905377416 },
  { x: 21.569354188752566, y: 12.5, z: 63.862248157047254 },
  { x: 7.893842878075099, y: 12.5, z: 63.86224815704725 },
  { x: 6.8908422652443733, y: 12.5, z: 64.862248157047254 },
  { x: 6.8908422652443733, y: 12.5, z: 73.29454732206058 },
  { x: 7.8908422652443733, y: 12.5, z: 74.07011841173752 },
  { x: 18.5622770924426, y: 12.5, z: 74.07011841173752 },
  { x: 19.5622770924426, y: 12.5, z: 70.30394905377416 },
  { x: 21.569354188752566, y: 12.5, z: 70.30394905377416 },
  { x: 21.143685863940448, y: 12.5, z: 72.62586492374183 },
  //下楼
  { x: 21.143685863940448, y: 10.2, z: 74.89163823687739 },
  { x: 20.143685863940448, y: 10.2, z: 74.16501161917118 },
  { x: 20.175733738189177, y: 8, z: 71.22510298455289 },
  { x: 20.28610585908347, y: 8, z: 69.41460378390302 },
  { x: 21.569354188752566, y: 8, z: 70.30394905377416 },
  { x: 21.143685863940448, y: 8, z: 72.62586492374183 },
  { x: 21.143685863940448, y: 6, z: 74.89163823687739 },
  { x: 20.143685863940448, y: 6, z: 74.16501161917118 },
  { x: 20.264417319753274, y: 2, z: 68.8859518369531 },
  { x: 21.498357221553757, y: 2, z: 69.0130599911824 },
  { x: 20.855994738513274, y: 2, z: 77.27606577324846 },
  { x: 20.855994738513274, y: 2, z: 89.20464061207659 },
  { x: 50.68272838049552, y: 2, z: 89.20464061207659 },
  { x: 70.90725527546952, y: 2, z: 89.50258271596418 },
  { x: 68.62223591011671, y: 2, z: 111.92264854322241 },
  { x: 54.16180529523262, y: 2.2, z: 111.73058844946237 },
];
const points9 = [
  { x: 64.81115157716746, y: 16.64462261107505, z: 111.67682452734756 },
  { x: 51.76180529523262, y: 2.2, z: 111.73058844946237 },
  { x: 50.51915290743494, y: 1, z: 111.60552699422354 },
  { x: 41.51915290743494, y: 1, z: 111.60552699422354 },
  { x: 33.51915290743494, y: 1, z: 111.60552699422354 },
  { x: 32.51915290743494, y: 2.2, z: 111.60552699422354 },
  { x: 31.81915290743494, y: 2.2, z: 111.60552699422354 },
  { x: 31.81915290743494, y: 2.2, z: 112.60552699422354 },
  { x: 31.81915290743494, y: 2.2, z: 118.60552699422354 },
];
const curve = new THREE.CatmullRomCurve3(
  [
    ...points1.map((i) => {
      return { x: i.x, y: i.y - 2, z: i.z };
    }),
    ...points2.map((i) => {
      return { x: i.x, y: i.y - 2, z: i.z };
    }),
    ...points3.map((i) => {
      return { x: i.x, y: i.y - 2, z: i.z };
    }),
    ...points4.map((i) => {
      return { x: i.x, y: i.y - 2, z: i.z };
    }),
    ...points5.map((i) => {
      return { x: i.x, y: i.y - 2, z: i.z };
    }),
    ...points6.map((i) => {
      return { x: i.x, y: i.y - 2, z: i.z };
    }),
    ...points7.map((i) => {
      return { x: i.x, y: i.y - 2, z: i.z };
    }),
    ...points8.map((i) => {
      return { x: i.x, y: i.y - 2, z: i.z };
    }),
    ...points9.map((i) => {
      return { x: i.x, y: i.y - 2, z: i.z };
    }),
  ],
  false,
  "catmullrom",
  0.3
);
const curve1 = new THREE.CatmullRomCurve3(points1, false, "catmullrom", 0.5);
const curve2 = new THREE.CatmullRomCurve3(points2, false, "catmullrom", 0.3);
const curve3 = new THREE.CatmullRomCurve3(points3, false, "catmullrom", 0.3);
const curve4 = new THREE.CatmullRomCurve3(points4, false, "catmullrom", 0.3);
const curve5 = new THREE.CatmullRomCurve3(points5, false, "catmullrom", 0.3);
const curve6 = new THREE.CatmullRomCurve3(points6, false, "catmullrom", 0.3);
const curve7 = new THREE.CatmullRomCurve3(points7, false, "catmullrom", 0.3);
const curve8 = new THREE.CatmullRomCurve3(points8, false, "catmullrom", 0.3);
const curve9 = new THREE.CatmullRomCurve3(points9, false, "catmullrom", 0.3);
const onTransfer = (from, to, camera, lookAt, duration = 2000, delay = 0) => {
  return new TWEEN.Tween(from)
    .to(to, duration)
    .onUpdate((t) => {
      camera.position.set(t.x, t.y, t.z);
      camera.lookAt(lookAt.x, lookAt.y, lookAt.z);
    })
    .delay(delay);
};

export let isPause = ref(false);
export let isPlay = ref(false);

let tagGroup = null;
const modelInfo = ref(null);
const activeStep = ref(0);

export default function Roam(scene, camera, controls) {
  let roamId = null;
  let originPosition = camera.position;
  let activeTween = ref(null);
  const skip = ref(false);
  const onSpeech = ref(false);

  function createTween(
    curve,
    duration,
    modelId,
    nextTween,
    finalPosition,
    finalTarget
  ) {
    return new TWEEN.Tween({ t: 0 })
      .to({ t: 1 }, duration)
      .easing(TWEEN.Easing.Linear.None)
      .onUpdate(function (t) {
        const point = curve.getPointAt(skip.value ? t.t / t.t : t.t);
        if (t.t + 0.01 <= 1 && !skip.value) {
          camera.position.copy(point);
          const lookPoint = curve.getPointAt(t.t + 0.01);
          camera.lookAt(lookPoint);
        } else {
          camera.position.copy(finalPosition);
          controls.target.copy(finalTarget);
          controls.update();
          modelInfo.value = ModelItems.find((i) => i.id === modelId);
          pause();
          activeTween.value = nextTween;
          activeStep.value++;
          onSpeech.value = true;
        }
      });
  }

  const tween9 = new TWEEN.Tween({ t: 0 })
    .to({ t: 1 }, 20000)
    .easing(TWEEN.Easing.Linear.None)
    .onUpdate(function (t) {
      const point = curve9.getPointAt(t.t);
      if (t.t + 0.01 <= 1) {
        camera.position.copy(point);
        const lookPoint = curve9.getPointAt(t.t + 0.01);
        camera.lookAt(lookPoint);
      } else {
        pause();
        isPlay.value = false;
        activeTween.value = tweenStare;
        activeStep.value++;
        modelInfo.value = null;
      }
    });
  const tween8 = createTween(
    curve8,
    60000,
    "J1",
    tween9,
    {
      x: 64.81115157716746,
      y: 16.64462261107505,
      z: 111.67682452734756,
    },
    {
      x: 23.973481623666963,
      y: -8.186846503744265,
      z: 111.3128347782172,
    }
  );
  const tween7 = createTween(
    curve7,
    30000,
    "J2",
    tween8,
    {
      x: 11.221795078357163,
      y: 36.88634341213497,
      z: 57.041247450952945,
    },
    {
      x: 11.272167031627745,
      y: 7.5386722464483045,
      z: 72.00080922090746,
    }
  );
  const tween6 = createTween(
    curve6,
    20000,
    "J4",
    tween7,
    {
      x: 24.437476594520604,
      y: 41.339680015921246,
      z: 19.89713055455814,
    },
    {
      x: 24.40641908810922,
      y: 4.043082798961535,
      z: 29.120651090955345,
    }
  );
  const tween5 = createTween(
    curve5,
    25000,
    "J5",
    tween6,
    {
      x: 47.46140101772576,
      y: 33.75322042034198,
      z: 4.616237570073371,
    },
    {
      x: 27.529084868199345,
      y: 0.9087681245194984,
      z: 4.851154408409407,
    }
  );
  const tween4 = createTween(
    curve4,
    20000,
    "J34",
    tween5,
    {
      x: 51.72591835138111,
      y: 21.511568580274545,
      z: -29.963124984921606,
    },
    {
      x: 63.28725722443339,
      y: 3.542934857218037,
      z: -18.570326567703702,
    }
  );
  // const tween3 = createTween(curve3, 20000, "J6_11", tween4);
  const tween2 = createTween(
    curve2,
    30000,
    "J8",
    tween4,
    {
      x: -16.2939380156945,
      y: 5.199925720279107,
      z: -100.2970150273196,
    },
    {
      x: -14.335447844051341,
      y: 2.6441057904338785,
      z: -100.06167246140804,
    }
  );
  const tween1 = createTween(
    curve1,
    20000,
    "J10_",
    tween2,
    {
      x: -114.82236360362995,
      y: 20.194156172625117,
      z: -18.06860052006201,
    },
    {
      x: -114.82798064755012,
      y: 18.707042404122696,
      z: -19.00609811662407,
    }
  );

  const tweenStare = new TWEEN.Tween(originPosition)
    .to(
      {
        x: -179.15640980749217,
        y: 5.709332403728519,
        z: 51.71824302547154,
      },
      2000
    )
    .onStart(() => {
      const J12 = scene.getObjectByName("J12");
      const J12D = scene.getObjectByName("J12-detail");
      J12.visible = false;
      J12D.visible = true;
    })
    .onUpdate(function (t) {
      camera.position.set(t.x, t.y, t.z);
      camera.lookAt(-170.6184453047966, 4.4991066615977005, 52.110563178544886);
    })
    .onComplete(() => {
      const J12 = scene.getObjectByName("J12");
      const J12D = scene.getObjectByName("J12-detail");
      activeStep.value = 0;
      activeTween.value = onTransfer(
        camera.position,
        curve1.getPointAt(0),
        camera,
        curve1.getPointAt(0.01),
        5000,
        3000
      )
        .start()
        .onComplete(() => {
          J12.visible = true;
          J12D.visible = false;
          activeTween.value = tween1;
          activeTween.value.start();
        });
    });

  const addRoute = () => {
    const points = curve.getPoints(3000);
    const lineGeometry = new LineGeometry();
    lineGeometry.setPositions(points.flatMap((p) => [p.x, p.y, p.z]));
    const lineMaterial = new LineMaterial({
      color: "#fff",
      linewidth: 10,
    });
    const line = new Line2(lineGeometry, lineMaterial);
    line.computeLineDistances();
    scene.add(line);
  };
  const start = () => {
    tagGroup = scene.getObjectByName("tags");
    if (!isPause.value) {
      activeTween.value = tweenStare;
    }
    modelInfo.value = null;
    tagGroup.visible = false;
    activeTween.value.start(undefined, isPause.value);
    isPlay.value = true;
    isPause.value = false;
    onSpeech.value = false;
    skip.value = false;
  };

  const stop = () => {
    activeTween.value.stop();
    activeStep.value = 0;
    isPlay.value = false;
    isPause.value = false;
    cancelAnimationFrame(roamId);
    camera.position.set(0, 200, 200);
    camera.lookAt(0, 0, 0);
    controls.reset();
    modelInfo.value = null;
    if (tagGroup) {
      tagGroup.visible = true;
    }
  };

  const pause = () => {
    activeTween.value.stop();
    isPause.value = true;
  };

  return {
    start,
    stop,
    pause,
    addRoute,
    isPlay,
    isPause,
    modelInfo,
    activeStep,
    onSpeech,
    skip,
  };
}